module.exports = __webpack_public_path__ + "img/9788962609783.f6f441c5.jpg";